import { UseCase } from "../useCase"
import { CompanyExcelRepository } from "../../repositories/CompanyExcelRepository"

interface Props {
	CompanyExcelRepository: CompanyExcelRepository
}

export class SendCompanyExcelEmailUseCase implements UseCase<number, { success: boolean; message: string }> {
	private _repository: CompanyExcelRepository

	constructor({ CompanyExcelRepository }: Props) {
		this._repository = CompanyExcelRepository
	}

	exec(companyExcelId: number): Promise<{ success: boolean; message: string }> {
		return this._repository.sendEmail(companyExcelId)
	}
}
